import { Link } from "react-router-dom";
import { ArrowRight, Database, HardDrive, Layers, Server } from "lucide-react";
import { Card, PageHeader } from "../components/ui.jsx";
import { useAuth } from "../auth.jsx";
import { OnboardingBlock } from "../components/Onboarding.jsx";

const choices = [
  { to: "/new/app", title: "Application service", description: "Deploy an app from a connected Git repository.", icon: Layers },
  { to: "/new/database", title: "Database", description: "Create PostgreSQL, Redis, MySQL, MariaDB, or MongoDB.", icon: Database },
  { to: "/new/server", title: "Server", description: "Provision a server to run your workloads.", icon: Server, adminOnly: true },
  { to: "/new/storage", title: "S3 object storage", description: "View object storage options and request a bucket for your services.", icon: HardDrive },
];

export default function NewService() {
  const { user } = useAuth();
  const available = choices.filter((choice) => !choice.adminOnly || user?.role === "admin");
  return (
    <div className="page space-y-6">
      <PageHeader title="New Service" subtitle="Choose the resource you want to create." />
      <OnboardingBlock />
      <div className="grid gap-4 md:grid-cols-2">
        {available.map(({ to, title, description, icon: Icon }) => (
          <Link key={to} to={to} className="block no-underline" style={{ color: "inherit" }}>
            <Card className="h-full transition-colors hover:border-blue-400">
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg" style={{ background: "var(--accent-soft)", color: "var(--accent-text)" }}><Icon size={21} /></span>
                <div className="min-w-0 flex-1">
                  <h2 className="font-semibold" style={{ color: "var(--text)" }}>{title}</h2>
                  <p className="mt-1 text-sm" style={{ color: "var(--text-muted)" }}>{description}</p>
                </div>
                <ArrowRight size={18} style={{ color: "var(--text-muted)" }} />
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
